import React, { useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'

const Cart = (props) => {
  const generalContext = useContext(GeneralContext)
  const { cartItemsCount } = generalContext

  const goToCart = () => {
    window.analytics.track("Go to cart")
    props.history.push('/carrito')
  }

  return (
    <React.Fragment>
      <div className="dropdown">
        <button
          type="button"
          onClick={goToCart}
          className="btn header-item noti-icon waves-effect"
        >
          {cartItemsCount ? cartItemsCount : ''}
          <i className="bx bx-cart"></i>
        </button>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Cart)
